export const getThemeLocalStorage = () => {
  return localStorage.getItem('theme') || 'light-theme';
};

export const setThemeLocalStorage = (theme) => {
  localStorage.setItem('theme', theme);
};
